export default __webpack_public_path__ + "static/media/randy-colas.fdf4d6d5.jpg";